export default __webpack_public_path__ + "static/media/warning-sign.4e267210.svg";